import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProducts } from '../context/ProductsContext';
import Footer from '../components/Footer';

const WhereItWorksPage: React.FC = () => {
  const navigate = useNavigate();
  const { products: apiProducts } = useProducts();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
  const [heroImage, setHeroImage] = useState<string>('');
  const [homeImage, setHomeImage] = useState<string>('');
  const [footballFieldImage, setFootballFieldImage] = useState<string>('');
  const [onTheGoImage, setOnTheGoImage] = useState<string>('');
  const [fallDetectionMobileImage, setFallDetectionMobileImage] = useState<string>('');
  const [fallDetectionBothImage, setFallDetectionBothImage] = useState<string>('');
  const [globeImage, setGlobeImage] = useState<string>('');
  const [productImages, setProductImages] = useState<{[key: string]: string}>({});
  const [cartIcon, setCartIcon] = useState<string>('');
  const [questionIcon, setQuestionIcon] = useState<string>('');
  const [phoneIcon, setPhoneIcon] = useState<string>('');
  const [mediaLogos, setMediaLogos] = useState<{
    abc: string;
    gma: string;
    frontiers: string;
    fox: string;
    florida: string;
    wbj: string;
    latimes: string;
  }>({
    abc: '',
    gma: '',
    frontiers: '',
    fox: '',
    florida: '',
    wbj: '',
    latimes: ''
  });

  useEffect(() => {
    // Fetch images
    fetch(`${API_URL}/api/images`)
      .then(res => res.json())
      .then((data: any) => {
        // Look for the hero image - 1704WhereItWorksTravel.jpg
        const hero = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('1704whereitworkstravel') ||
          img.filename.toLowerCase().includes('whereitworkstravel') ||
          (img.filename.toLowerCase().includes('1704') && img.filename.toLowerCase().includes('travel'))
        );
        if (hero) {
          setHeroImage(`${API_URL}/api/images/${hero.id}`);
        }

        // Home protection couple image
        const home = data.images.find((img: any) => 
          img.filename === '1704WhereItWorksCouple.jpg'
        );
        if (home) {
          setHomeImage(`${API_URL}/api/images/${home.id}`);
        }

        // Football field image
        const footballField = data.images.find((img: any) => 
          img.filename === '1704WhereItWorksFootballField.png'
        );
        if (footballField) {
          setFootballFieldImage(`${API_URL}/api/images/${footballField.id}`);
        }

        // On-the-go wristband image
        const onTheGo = data.images.find((img: any) => 
          img.filename === 'wristband-1704-circle-1.jpg'
        );
        if (onTheGo) {
          setOnTheGoImage(`${API_URL}/api/images/${onTheGo.id}`);
        }

        // Fall detection mobile - keep current logic (fourth is correct)
        const fallMobile = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('swing') ||
          img.filename.toLowerCase().includes('playground')
        );
        if (fallMobile) {
          setFallDetectionMobileImage(`${API_URL}/api/images/${fallMobile.id}`);
        }

        // Fall detection both - woman image
        const fallBoth = data.images.find((img: any) => 
          img.filename === '1704WhereItWorksWoman.jpg'
        );
        if (fallBoth) {
          setFallDetectionBothImage(`${API_URL}/api/images/${fallBoth.id}`);
        }

        // Coverage map - 50 states
        const globe = data.images.find((img: any) => 
          img.filename === '211HowItWorksCoverageMap.png'
        );
        if (globe) {
          setGlobeImage(`${API_URL}/api/images/${globe.id}`);
        }

        // Get product images from API products
        const imageMap: {[key: string]: string} = {};
        console.log('API Products count:', apiProducts.length);
        apiProducts.forEach(product => {
          console.log('Processing product:', product.shortName, 'imageFilename:', product.imageFilename);
          if (product.imageFilename) {
            const img = data.images.find((i: any) => i.filename === product.imageFilename);
            if (img) {
              imageMap[product.shortName] = `${API_URL}/api/images/${img.id}`;
              console.log('✓ Found image for', product.shortName);
            } else {
              console.log('✗ Image not found for', product.shortName, '- looking for:', product.imageFilename);
            }
          }
        });
        console.log('Product images map:', imageMap);
        setProductImages(imageMap);

        // Look for media logos
        const logos: any = {};
        
        const abc = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('abc') && 
          !img.filename.toLowerCase().includes('gma')
        );
        if (abc) logos.abc = `${API_URL}/api/images/${abc.id}`;

        const gma = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('gma') ||
          (img.filename.toLowerCase().includes('good') && img.filename.toLowerCase().includes('morning'))
        );
        if (gma) logos.gma = `${API_URL}/api/images/${gma.id}`;

        const frontiers = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('medicalalertsystemshomepagefronteirs') ||
          img.filename.toLowerCase().includes('medicalalertsystemshomepagefrontiers')
        );
        if (frontiers) logos.frontiers = `${API_URL}/api/images/${frontiers.id}`;

        const fox = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('medicalalertsystemshomepagefox')
        );
        if (fox) logos.fox = `${API_URL}/api/images/${fox.id}`;

        const florida = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('medicalalertsystemshomepageflorida')
        );
        if (florida) logos.florida = `${API_URL}/api/images/${florida.id}`;

        const wbj = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('medicalalertsystemshomepagewbj')
        );
        if (wbj) logos.wbj = `${API_URL}/api/images/${wbj.id}`;

        const latimes = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('medicalalertsystemshomepagela')
        );
        if (latimes) logos.latimes = `${API_URL}/api/images/${latimes.id}`;

        setMediaLogos(logos);

        // Look for help section icons
        const cart = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('1704whereitworkscarticon') ||
          (img.filename.toLowerCase().includes('cart') && img.filename.toLowerCase().includes('icon'))
        );
        if (cart) setCartIcon(`${API_URL}/api/images/${cart.id}`);

        const question = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('1704whereitworksquestionicon') ||
          (img.filename.toLowerCase().includes('question') && img.filename.toLowerCase().includes('icon'))
        );
        if (question) setQuestionIcon(`${API_URL}/api/images/${question.id}`);

        const phone = data.images.find((img: any) => 
          img.filename.toLowerCase().includes('1704whereitworksphoneicon') ||
          (img.filename.toLowerCase().includes('phone') && img.filename.toLowerCase().includes('icon'))
        );
        if (phone) setPhoneIcon(`${API_URL}/api/images/${phone.id}`);
      })
      .catch(err => console.error('Error fetching images:', err));
  }, [API_URL, apiProducts]);

  return (
    <div className="where-it-works-page">
      {/* Hero Section */}
      <section className="where-hero-section">
        <div className="where-hero-container">
          <div className="where-hero-content">
            <h1 className="where-hero-title">Medical Alert System Range: In-Home or On-the-Go</h1>
            
            <p className="where-hero-paragraph">
              A medical alert system from Alert1 brings you help at the push of a button 24/7. There are 2 different range options-- in-home coverage (including an area 400 feet around the base unit) or mobile coverage (anywhere in the USA, parts of Canada, and Puerto Rico).
            </p>
            
            <p className="where-hero-paragraph">
              Fall detection can be added to any Alert1 med alert device. If you plan to use your device in-home only but prefer an all-in-one unit (no separate base unit and the speaker is built right into the pendant or wristband), then we recommend selecting one of our Mobile GPS alert systems. We have something for every preference!
            </p>
            
            <button className="where-view-systems-btn" onClick={() => navigate('/medical-alerts')}>VIEW SYSTEMS</button>
          </div>
          
          <div className="where-hero-image">
            {heroImage ? (
              <img src={heroImage} alt="Couple traveling" className="where-hero-img" />
            ) : (
              <div className="where-hero-placeholder">
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
                  <circle cx="200" cy="200" r="180" fill="#f0f0f0"/>
                  <circle cx="200" cy="160" r="60" fill="#d0d0d0"/>
                  <ellipse cx="200" cy="300" rx="100" ry="120" fill="#d0d0d0"/>
                </svg>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Home Protection Section */}
      <section className="where-home-section">
        <div className="where-home-banner">
          <p className="where-home-banner-text">
            Call <a href="tel:1-877-579-9862" className="where-home-banner-phone">1-877-579-9862</a> for any questions
          </p>
        </div>
        
        <div className="where-home-container">
          <div className="where-home-image">
            {homeImage ? (
              <img src={homeImage} alt="Couple at home with medical alert" className="where-home-img" />
            ) : (
              <div className="where-home-placeholder">
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
                  <circle cx="200" cy="200" r="180" fill="#f0f0f0"/>
                  <circle cx="200" cy="160" r="60" fill="#d0d0d0"/>
                  <ellipse cx="200" cy="300" rx="100" ry="120" fill="#d0d0d0"/>
                </svg>
              </div>
            )}
          </div>
          
          <div className="where-home-content">
            <h2 className="where-home-title">Can I be protected at home? Yes you can!</h2>
            
            <p className="where-home-paragraph">
              Our home and fall detection systems protect you in and around your home. Push the button and get help fast with Alert1's classic medical alert system.
            </p>
            
            <p className="where-home-paragraph">
              No landline? No problem! We have every type of medical alert system to fit your needs. With any emergency, big or small, just press your help button.
            </p>
            
            <p className="where-home-paragraph">
              A trained operator at one of our <strong>Command Centers</strong> will have personalized help on the way immediately. With Alert1, you will never be alone in an emergency situation. We stay on the line with you until help arrives. Your family members, neighbors, or doctor will notified that help is on the way.
            </p>
          </div>
        </div>
      </section>

      {/* Football Fields Range Section */}
      <section className="where-football-section">
        <div className="where-football-container">
          <h2 className="where-football-title">Two football fields worth of range.</h2>
          
          <div className="where-football-image-wrapper">
            {footballFieldImage ? (
              <div className="where-football-images">
                <img src={footballFieldImage} alt="Football field 1" className="where-football-img" />
                <img src={footballFieldImage} alt="Football field 2" className="where-football-img" />
              </div>
            ) : (
              <div className="where-football-placeholder">
                <div className="where-football-placeholder-content">
                  <div className="where-football-arrow-left">←</div>
                  <div className="where-football-text">400 feet</div>
                  <div className="where-football-arrow-right">→</div>
                </div>
                <div className="where-football-fields">
                  <div className="where-football-field"></div>
                  <div className="where-football-field"></div>
                </div>
              </div>
            )}
          </div>

          <p className="where-football-paragraph">
            Our home medical alert system gives you a generous 400-foot range around the base unit that easily covers most homes and yards. That's nearly two football fields placed end-to-end! Now you can walk over and get the mail or spend time chatting with your neighbor across the fence or read in your backyard – all while still having access to help at the touch of a button.
          </p>

          <p className="where-football-paragraph">
            Each medical alert unit is independently tested for performance before it arrives at your door. Once your system arrives, we ask you to test your system throughout your home for your peace of mind.
          </p>

          <p className="where-football-paragraph">
            For additional security, you can add fall detection to your home system.
          </p>

          <p className="where-football-paragraph">
            <strong>Waterproof for shower safety:</strong> All Alert1 medical alerts are 100% showerproof. You can do everything from gardening to washing your dog to preparing meals and showering – all while wearing your alert button.
          </p>
        </div>
      </section>

      {/* Compare Button Section */}
      <section className="where-compare-section">
        <button className="where-compare-btn" onClick={() => navigate('/compare')}>COMPARE MEDICAL ALERT SYSTEMS</button>
      </section>

      {/* On-the-Go Section */}
      <section className="where-on-the-go-section">
        <div className="where-on-the-go-container">
          <div className="where-on-the-go-content">
            <h2 className="where-on-the-go-title">Can I be protected on-the-go? Yes you can!</h2>
            
            <p className="where-on-the-go-paragraph">
              For those who want help at the touch of a button anywhere they go, we have mobile medical alert systems with GPS and optional fall detection. No base station or landline phone is needed!
            </p>
            
            <p className="where-on-the-go-paragraph">
              When you press the button on your alert pendant or wristband, you will be connected to our Command Center via two-way voice communication. They will connect to you in seconds to ask if you need help, and can send help from your personalized list of emergency contacts or from any emergency services--whatever you need and prefer.
            </p>
            
            <p className="where-on-the-go-paragraph">
              If you need help and do not know where you are, the Command Center will use patented technology to send help to your location.
            </p>

            <button className="where-view-system-btn" onClick={() => navigate('/products/lifebeacon')}>VIEW SYSTEM</button>
          </div>
          
          <div className="where-on-the-go-image">
            {onTheGoImage ? (
              <img src={onTheGoImage} alt="Couple golfing" className="where-on-the-go-img" />
            ) : (
              <div className="where-on-the-go-placeholder">
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
                  <circle cx="200" cy="200" r="180" fill="#f0f0f0"/>
                  <circle cx="200" cy="160" r="60" fill="#d0d0d0"/>
                  <ellipse cx="200" cy="300" rx="100" ry="120" fill="#d0d0d0"/>
                </svg>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Fall Detection Mobile Section */}
      <section className="where-fall-mobile-section">
        <div className="where-fall-mobile-container">
          <div className="where-fall-mobile-image">
            {fallDetectionMobileImage ? (
              <img src={fallDetectionMobileImage} alt="Person on swing" className="where-fall-mobile-img" />
            ) : (
              <div className="where-fall-mobile-placeholder">
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
                  <circle cx="200" cy="200" r="180" fill="#f0f0f0"/>
                  <circle cx="200" cy="160" r="60" fill="#d0d0d0"/>
                  <ellipse cx="200" cy="300" rx="100" ry="120" fill="#d0d0d0"/>
                </svg>
              </div>
            )}
          </div>

          <div className="where-fall-mobile-content">
            <h2 className="where-fall-mobile-title">Can I be protected on-the-go with fall detection? Yes you can!</h2>
            
            <p className="where-fall-mobile-paragraph">
              Alert1 offers mobile protection with fall detection in medical alert devices with multiple wearable options (pendant, bracelet/wristband, belt clip).
            </p>
            
            <p className="where-fall-mobile-paragraph">
              No base station, landline, WiFi, or cell phone is needed.
            </p>
            
            <p className="where-fall-mobile-paragraph">
              When you press the button or the alert device senses a fall, you will be connected to a caring operator at the Alert1 Command Center. If you are unable to speak, we will send help from your personal emergency contacts list or EMS.
            </p>
            
            <p className="where-fall-mobile-paragraph">
              Even if you do not know where you are, our mobile fall detection alerts use GPS technology or location services to pinpoint your location.
            </p>

            <button className="where-view-system-btn" onClick={() => navigate('/products/lifebeacon')}>VIEW SYSTEM</button>
          </div>
        </div>
      </section>

      {/* Fall Detection Both Section */}
      <section className="where-fall-both-section">
        <div className="where-fall-both-container">
          <div className="where-fall-both-content">
            <h2 className="where-fall-both-title">Is fall detection available for in-home and on-the-go button alarms? Yes!</h2>
            
            <p className="where-fall-both-paragraph">
              For maximum comfort and security, Alert1 offers the option of adding our dependable fall detection feature to both in-home and on-the-go medical alerts for seniors and others seeking the highest level of protection and care.
            </p>
            
            <p className="where-fall-both-paragraph">
              Alert1's In-Home + Fall Detection Medical Alert has built-in sensors in the pendant that can sense falls and automatically send an alert to our Command Center (of course, you can always push your emergency button at any time). This system works in and around the home, and communication takes place through the base station.
            </p>
            
            <p className="where-fall-both-paragraph">
              When you're out and about, our On-the-Go + GPS + Fall Detection personal emergency alarm is the perfect option for your needs and lifestyle. You'll enjoy automatic fall detection protection everywhere you go in all 50 US states, as well as parts of Canada and Puerto Rico!
            </p>

            <button className="where-view-system-btn" onClick={() => navigate('/medical-alerts')}>VIEW SYSTEMS</button>
          </div>
          
          <div className="where-fall-both-image">
            {fallDetectionBothImage ? (
              <img src={fallDetectionBothImage} alt="Senior with medical alert pendant" className="where-fall-both-img" />
            ) : (
              <div className="where-fall-both-placeholder">
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
                  <circle cx="200" cy="200" r="180" fill="#f0f0f0"/>
                  <circle cx="200" cy="160" r="60" fill="#d0d0d0"/>
                  <ellipse cx="200" cy="300" rx="100" ry="120" fill="#d0d0d0"/>
                </svg>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Comparison Table Section */}
      <section className="where-comparison-section">
        <div className="where-comparison-container">
          <h2 className="where-comparison-title">Where would you like to be protected?</h2>
          
          <p className="where-comparison-intro">
            We have many options from which to choose! Whether you want to be protected at home or on the go, with Alert1 you have the peace of mind of 24/7 protection. Give us a call today and we can help you select the system that best meets your needs, lifestyle, and budget.
          </p>

          <div className="where-comparison-table-wrapper">
            <table className="where-comparison-table">
              <thead>
                <tr>
                  <th className="where-comparison-table-title" colSpan={4}>Choose Your System</th>
                </tr>
                <tr>
                  <th className="where-comparison-header-empty"></th>
                  <th className="where-comparison-header">
                    <div className="where-comparison-product">
                      <div className="where-comparison-product-image">
                        {productImages['ez-care'] ? (
                          <img src={productImages['ez-care']} alt="Home EZ Care" />
                        ) : (
                          <svg width="120" height="80" viewBox="0 0 120 80" fill="none">
                            <rect width="120" height="80" fill="#f0f0f0" rx="4"/>
                          </svg>
                        )}
                      </div>
                      <div className="where-comparison-product-name">Home EZ Care</div>
                    </div>
                  </th>
                  <th className="where-comparison-header">
                    <div className="where-comparison-product">
                      <div className="where-comparison-product-image">
                        {productImages['ez-care-plus'] ? (
                          <img src={productImages['ez-care-plus']} alt="Home EZ Care Plus" />
                        ) : (
                          <svg width="120" height="80" viewBox="0 0 120 80" fill="none">
                            <rect width="120" height="80" fill="#f0f0f0" rx="4"/>
                          </svg>
                        )}
                      </div>
                      <div className="where-comparison-product-name">Home EZ Care Plus</div>
                    </div>
                  </th>
                  <th className="where-comparison-header">
                    <div className="where-comparison-product">
                      <div className="where-comparison-product-image">
                        {productImages['lifebeacon'] ? (
                          <img src={productImages['lifebeacon']} alt="LifeBeacon On-the-Go" />
                        ) : (
                          <svg width="120" height="80" viewBox="0 0 120 80" fill="none">
                            <rect width="120" height="80" fill="#f0f0f0" rx="4"/>
                          </svg>
                        )}
                      </div>
                      <div className="where-comparison-product-name">LifeBeacon On-the-Go Pendant/Wristband</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="where-comparison-feature">Nationwide Coverage</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                </tr>
                <tr>
                  <td className="where-comparison-feature">Range</td>
                  <td className="where-comparison-value">400 feet</td>
                  <td className="where-comparison-value">400 feet</td>
                  <td className="where-comparison-value">Everywhere</td>
                </tr>
                <tr>
                  <td className="where-comparison-feature">Coverage Network</td>
                  <td className="where-comparison-value">Landline (including VOIP)</td>
                  <td className="where-comparison-value">AT&T or T-Mobile</td>
                  <td className="where-comparison-value">AT&T or T-Mobile</td>
                </tr>
                <tr>
                  <td className="where-comparison-feature">GPS/Location Services</td>
                  <td className="where-comparison-value">NO</td>
                  <td className="where-comparison-value">NO</td>
                  <td className="where-comparison-value">YES</td>
                </tr>
                <tr>
                  <td className="where-comparison-feature">Optional Fall Detection</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                </tr>
                <tr>
                  <td className="where-comparison-feature">Pre-Loaded Personal Medical Profile</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                </tr>
                <tr>
                  <td className="where-comparison-feature">Pairable with a Smoke Detector</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                  <td className="where-comparison-value">YES</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* 50 States Coverage Section */}
      <section className="where-coverage-section">
        <div className="where-coverage-container">
          <div className="where-coverage-image">
            {globeImage ? (
              <img src={globeImage} alt="Alert1 Coverage Map" className="where-coverage-img" />
            ) : (
              <div className="where-coverage-placeholder">
                <svg width="400" height="400" viewBox="0 0 400 400" fill="none">
                  <circle cx="200" cy="200" r="180" fill="#4a90e2"/>
                  <circle cx="200" cy="200" r="160" fill="#357abd"/>
                  <circle cx="200" cy="200" r="140" fill="#2563a8"/>
                </svg>
              </div>
            )}
          </div>
          
          <div className="where-coverage-content">
            <h2 className="where-coverage-title">Alert1 Works in All 50 States!</h2>
            
            <p className="where-coverage-paragraph">
              Alert1 provides medical alert system service across the entire <strong>United States</strong>, <strong>Canada</strong> and <strong>Puerto Rico</strong>. We work with local and national emergency services (EMT, Fire, Police, etc.) to ensure that you or your loved one get help quickly when needed.
            </p>
            
            <p className="where-coverage-paragraph">
              When you choose to stay protected with Alert1, help is only a button push away. Our <strong>TMA 5-Diamond Certified Command Centers</strong> are ready to assist you 24/7. Capable and caring operators will get you the help you need. With your personalized responder list, and multi-lingual protection, you will be in the best of hands with Alert1.
            </p>
          </div>
        </div>

        <div className="where-coverage-footer">
          <p className="where-coverage-footer-text">
            From our <strong>In-Home</strong> pendants to our <strong>On-the-Go</strong> medical alarms, Alert1 has you covered. Our home systems do not need require landlines to keep you connected. All our mobile medical alert systems use cellular phone service to keep you safe on the go.
          </p>
          
          <p className="where-coverage-footer-text">
            Additionally, our <strong>Mobile Fall Detection</strong> system and <strong>On-the-Go + In-Home + Fall Detection</strong> system use GPS technology to pinpoint your location during an emergency. You don't need to worry about adding any sort of phone coverage for our medical alerts—we set up and program everything for you and your alert arrives ready to use.
          </p>
          
          <p className="where-coverage-footer-text">
            Alert1 members enjoy peace of mind from coast to coast. Alert1 is committed to helping retirees across the country live independently by providing <strong>affordable and reliable medical alert services</strong>.
          </p>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="where-cta-section">
        <div className="where-cta-container">
          <button className="where-cta-view-systems-btn" onClick={() => navigate('/medical-alerts')}>VIEW SYSTEMS</button>
          
          <p className="where-cta-phone-text">
            Call <a href="tel:1-877-579-9862" className="where-cta-phone-link">1-877-579-9862</a> to talk to a New Member Specialist now!
          </p>
        </div>
      </section>

      {/* Get Help Fast Section */}
      <section className="where-help-section">
        <div className="where-help-container">
          <h2 className="where-help-title">Get the help you need fast.</h2>
          
          <div className="where-help-options">
            <div className="where-help-option">
              <div className="where-help-icon">
                {cartIcon ? (
                  <img src={cartIcon} alt="Order Online" className="where-help-icon-img" />
                ) : (
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="9" cy="21" r="1"/>
                    <circle cx="20" cy="21" r="1"/>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                  </svg>
                )}
              </div>
              <h3 className="where-help-option-title">ORDER ONLINE</h3>
              <p className="where-help-option-text">
                Order your medical alert online. Most orders are shipped same day.
              </p>
            </div>

            <div className="where-help-divider">
              <div className="where-help-divider-line"></div>
            </div>

            <div className="where-help-option">
              <div className="where-help-icon">
                {questionIcon ? (
                  <img src={questionIcon} alt="Questions" className="where-help-icon-img" />
                ) : (
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                    <line x1="12" y1="17" x2="12.01" y2="17"/>
                  </svg>
                )}
              </div>
              <h3 className="where-help-option-title">QUESTIONS?</h3>
              <p className="where-help-option-text">
                Get additional information from an Alert1 New Member Specialist.
              </p>
            </div>

            <div className="where-help-divider">
              <div className="where-help-divider-line"></div>
            </div>

            <div className="where-help-option">
              <div className="where-help-icon">
                {phoneIcon ? (
                  <img src={phoneIcon} alt="Call Us" className="where-help-icon-img" />
                ) : (
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                )}
              </div>
              <h3 className="where-help-option-title">CALL US</h3>
              <p className="where-help-option-text">
                Get answers to your questions about the Alert1 medical alert and pricing.
              </p>
              <p className="where-help-option-phone">
                <a href="tel:1-877-579-9862">1-877-579-9862</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted and Recommended Section */}
      <section className="where-trusted-section">
        <div className="where-trusted-container">
          <h2 className="where-trusted-title">Trusted and Recommended</h2>
          
          <div className="where-trusted-logos">
            <div className="where-trusted-logo-row">
              {mediaLogos.abc && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.abc} alt="ABC News" />
                </div>
              )}
              {mediaLogos.gma && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.gma} alt="Good Morning America" />
                </div>
              )}
              {mediaLogos.frontiers && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.frontiers} alt="Frontiers in Robotics and AI" />
                </div>
              )}
              {mediaLogos.fox && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.fox} alt="Fox News" />
                </div>
              )}
            </div>
            
            <div className="where-trusted-logo-row">
              {mediaLogos.florida && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.florida} alt="The Florida Times-Union" />
                </div>
              )}
              {mediaLogos.wbj && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.wbj} alt="Washington Business Journal" />
                </div>
              )}
              {mediaLogos.latimes && (
                <div className="where-trusted-logo">
                  <img src={mediaLogos.latimes} alt="Los Angeles Times" />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default WhereItWorksPage;

